import { WageGroup } from '../objects/WageGroup';
import { ResourceEndpoint } from './ResourceEndpoint';

export class WageGroupEndpoint extends ResourceEndpoint {
    constructor(url, api) {
        super(url, api, WageGroup);
    }

    getUrl(wageGroup) {
        if (!(wageGroup instanceof WageGroup)) {
            throw new TypeError('Invalid Argument');
        }
        return this.url + '/' + encodeURIComponent(wageGroup.Id);
    }

    addRound(wageGroup, year, month, senderName) {
        var dst = this.getUrl(wageGroup) + '/addround';
        return this._api.postVoid(dst, {
            Id: wageGroup.Id,
            RowVersion: wageGroup.RowVersion,
            Year: year,
            Month: month,
            SenderName: senderName
        });
    }

    lockRound(wageGroup, locked) {
        var dst = this.getUrl(wageGroup) + '/lockround';
        return this._api.postVoid(dst, {
            Id: wageGroup.Id,
            RowVersion: wageGroup.RowVersion,
            IsLocked: !!locked
        });
    }

    removeRound(wageGroup) {
        var dst = this.getUrl(wageGroup) + '/removeround';
        return this._api.postVoid(dst, {
            Id: wageGroup.Id,
            RowVersion: wageGroup.RowVersion
        });
    }

    addVersion(wageGroup, senderName) {
        var dst = this.getUrl(wageGroup) + '/addversion';
        return this._api.postVoid(dst, {
            Id: wageGroup.Id,
            RowVersion: wageGroup.RowVersion,
            SenderName: senderName
        });
    }
}
